<button class="button" type="button" role="button" [ngClass]="['button--' + color, 'button--' + size, disabled ? 'button--disabled' : '', wide ? 'wide' : '', addBlur ? 'blur' : '']" [tabIndex]="disabled ? -1 : 0" *ngIf="type === 'button'">
  <span class="icon icon--before" *ngIf="showLoader"><brt-loader></brt-loader></span>
  <span class="icon icon--before" *ngIf="beforeIcon"><brt-icon [icon]="beforeIcon"></brt-icon></span>
  <span class="title">{{title}}</span>
  <span class="icon icon--after" *ngIf="afterIcon"><brt-icon [icon]="afterIcon"></brt-icon></span>
</button>

<div class="button" [ngClass]="['button--' + color, 'button--' + size, disabled ? 'button--disabled' : '', wide ? 'wide' : '', addBlur ? 'blur' : '']" [tabIndex]="-1" *ngIf="type === 'link'">
  <span class="icon icon--before" *ngIf="showLoader"><brt-loader></brt-loader></span>
  <span class="icon icon--before" *ngIf="beforeIcon"><brt-icon [icon]="beforeIcon"></brt-icon></span>
  <span class="title">{{title}}</span>
  <span class="icon icon--after" *ngIf="afterIcon"><brt-icon [icon]="afterIcon"></brt-icon></span>
</div>

